import React, { useState, useEffect, useRef } from 'react';
import {
    Container,
    TextField,
    Button,
    FormControl,
    Typography,
    Autocomplete,
    InputAdornment
} from '@mui/material';
import Barcode from 'react-barcode';
import { useReactToPrint } from 'react-to-print';
import axios from 'axios';
import SearchIcon from '@mui/icons-material/Search'; // Importing Search icon
import { BRAND } from '../constants/brand';

function BarcodeGenerator() {
    const [products, setProducts] = useState([]);
    const [selectedProduct, setSelectedProduct] = useState(null); // Changed to null to work with Autocomplete
    const [quantity, setQuantity] = useState(1);
    const [barcodes, setBarcodes] = useState([]);
    const [searchBarcode, setSearchBarcode] = useState(''); // State to handle search by barcode

    const componentRef = useRef();

    // Fetch product data from the API when the component mounts
    useEffect(() => {
        axios.get('https://serverukautotech.ccsoftwares.com/Item/getItemDetailsforGeneration')
            .then(res => { setProducts(res.data); })
            .catch(error => console.error('Error fetching product data:', error));
    }, []);

    // Generate barcodes based on the selected product and quantity
    const handleGenerate = () => {
        const barcodeList = [];
        for (let i = 0; i < quantity; i++) {
            barcodeList.push(selectedProduct);
        }
        setBarcodes(barcodeList);
    };

    // Handle the print action
    const handlePrint = useReactToPrint({
        content: () => componentRef.current,
        documentTitle: 'Barcodes'
    });

    // Handle the search by barcode functionality
    const handleBarcodeSearch = (event) => {
        setSearchBarcode(event.target.value);
    };

    // Filter products based on barcode search
    const filteredProducts = products.filter(product =>
        product.ItemID.toString().includes(searchBarcode) || // Match the barcode
        product.ItemName.toLowerCase().includes(searchBarcode.toLowerCase()) // Optionally match item name
    );

    return (
        <Container maxWidth="sm" style={{ marginTop: '0em', paddingTop: '10em' }}>
            <Typography variant="h4" gutterBottom>
                {`${BRAND.name} Barcode Generator`}
            </Typography>
            

            {/* Searchable Dropdown using Autocomplete */}
            <Autocomplete
                value={selectedProduct}
                onChange={(event, newValue) => setSelectedProduct(newValue)} // Sets the selected product
                disablePortal
                id="product-search"
                options={filteredProducts} // Use filtered products based on barcode search
                getOptionLabel={(option) => option.ItemName} // Displays the product name in the dropdown
                isOptionEqualToValue={(option, value) => option.ItemID === value.ItemID} // Ensures the selected option is valid
                renderInput={(params) => <TextField {...params} label="Select Product" fullWidth />}
                style={{ marginBottom: '1em' }}
            />



            <TextField
                type="number"
                label="Number of Barcodes"
                value={quantity}
                onChange={(e) => setQuantity(e.target.value)}
                fullWidth
                style={{ marginBottom: '1em' }}
                inputProps={{ min: 1 }}
            />

<div
    style={{
        display: 'flex',
        justifyContent: 'center', // Center horizontally
    }}
>
    <div>
        <Button
            variant="contained"
            color="primary"
            onClick={handleGenerate}
            style={{ marginRight: '1em' }}
            disabled={!selectedProduct}
        >
            Generate
        </Button>
        <Button
            variant="contained"
            color="primary"
            onClick={handlePrint}
            disabled={barcodes.length === 0}
        >
            Print
        </Button>
    </div>
</div>


            {/* Display generated barcodes */}
        {barcodes.length > 0 && (
  <div style={{ display: 'flex', justifyContent: 'center' }}>
    <div
      ref={componentRef}
      style={{
        marginTop: 0,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
      }}
    >
      {barcodes.map((code, index) => (
        <React.Fragment key={index}>
          {/* spacer only between labels (keeps separation across page breaks) */}
          {index !== 0 && <div style={{ height: '3mm' }} />}

          <div
            className="barcode-container"
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'space-between',   // distribute content to fit 25mm
              width: '200px',                     // keep your width (set in px or change to mm if you prefer)
              height: '25mm',                     // *** exact label height ***
              padding: '1mm 0',                   // small breathing room
              boxSizing: 'border-box',
              overflow: 'hidden',
              pageBreakInside: 'avoid',
              breakInside: 'avoid',
            }}
          >
            {/* Barcode (bars only) ~14mm tall */}
            <Barcode
              value={code.ItemID.toString()}
              width={1.2}              // bar width
              height={53}              // ≈14mm at 96dpi (14 * 3.78)
              format="CODE128"
              displayValue={false}     // hide built-in text to save height
              margin={0}
              renderer="svg"
              style={{ maxWidth: '100%' }}
            />

            {/* Compact text block to fit remaining space */}
            <div style={{ textAlign: 'center', lineHeight: 1.1 }}>
              <div style={{ fontSize: '3mm', margin: 0 }}>{code.ItemID}</div>
              <div style={{ fontSize: '3.2mm', fontWeight: 'bold', margin: 0 }}>
                {code.ItemName}
              </div>
              <div style={{ fontSize: '3.2mm', fontWeight: 'bold', margin: 0 }}>
                Rs.{code.sellingPrice} | {BRAND.name}
              </div>
            </div>
          </div>
        </React.Fragment>
      ))}
    </div>
  </div>
)}

        </Container>
    );
}

export default BarcodeGenerator;
